import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'jaNee'
})
export class JaNeePipe implements PipeTransform {

  constructor(private _translateService: TranslateService) {

  }


  transform(value: unknown, ...args: unknown[]): unknown {
    return value ? this._translateService.instant('ALGEMEEN.JA') : this._translateService.instant('ALGEMEEN.NEE');
  }

}
